import { render, staticRenderFns } from "./BillingPage.vue?vue&type=template&id=477b385c&scoped=true&"
import script from "./BillingPage.vue?vue&type=script&lang=ts&"
export * from "./BillingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477b385c",
  null
  
)

export default component.exports